<app-icon-button
  [iconLigature]="config.iconLigature"
  (click)="share()"
  [tooltipText]="config.ariaLabel | translate"
  [location]="location"></app-icon-button>
